import { styled } from 'linaria/react';

export const ButtonContainer = styled('div')`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	
	& > button {
		width: 100%;
	}
`;
